import React, { useState } from "react"
import HostingIndexPage2 from "pages/WorkModule/Hosting/HostingIndex2"
import DashPendingInvoices from "./DashPendingInvoices"

const TABS = [
    { key: "hosting", label: "Hosting", icon: "bx bx-server" },
    { key: "invoice", label: "Pending Invoices", icon: "bx bx-receipt" },
]

const HostingAndInvoices = () => {
    const [activeTab, setActiveTab] = useState("hosting")

    return (
        <div className="p-0">
            <div className="px-3 pt-3 pb-2">
                <h5 className="fw-semibold mb-0" style={{ color: "#752a97" }}>
                    <i className="bx bx-layer me-2"></i>
                    Hosting & Invoices
                </h5>
            </div>
            {/* Tab Header */}
            <div className="d-flex align-items-center" style={{ borderBottom: "2px solid #e9ecef" }}>
                {TABS.map(tab => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className="btn btn-sm fw-semibold px-4 py-2 rounded-0"
                        style={{
                            color: activeTab === tab.key ? "#752a97" : "#6c757d",
                            background: "transparent",
                            border: "none",
                            borderBottom: activeTab === tab.key ? "3px solid #752a97" : "3px solid transparent",
                            marginBottom: "-2px",
                            transition: "color 0.15s, border-color 0.15s",
                        }}
                    >
                        <i className={`${tab.icon} me-1`}></i>
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div>
                {activeTab === "hosting" && (
                    <HostingIndexPage2 dashElement={true} showTitle={false} />
                )}
                {activeTab === "invoice" && (
                    <DashPendingInvoices />
                )}
            </div>
        </div>
    )
}

export default HostingAndInvoices
